import { HelpMessage } from 'utils/constants'
import UserRoleSelectProvider from 'components/CIMSSelect/common/UserRoleSelect/UserRoleSelectContext'
import CIMSTable from 'components/CIMSTable'
import {
  useProjectCustomFieldsContext,
  ProjectCustomFieldsProvider,
} from 'components/CustomFields/ProjectCustomFieldsContext'
import {
  useCustomFieldPageContext,
  CustomFieldPageProvider,
} from './CustomFieldPageContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'

const CustomFieldsTable: React.FC = () => {
  const { customFields, fetching, refetch } = useProjectCustomFieldsContext()
  const {
    remove: { is: removing },
    restore: { is: restoring },
  } = useCustomFieldPageContext()
  const columns = useColumns()
  const create = useCreate()
  const edit = useEdit()
  const remove = useRemove()
  const restore = useRestore()
  const expand = useExpand()
  return (
    <CIMSTable
      rowKey="id"
      records={customFields}
      details={`${HelpMessage.Administration.CustomFields.Editors}.`}
      columns={columns}
      key="custom-fields-table"
      loading={fetching || removing || restoring}
      expand={expand}
      actions={{
        header: { onReload: refetch, create },
        row: {
          help: HelpMessage.Administration.CustomFields.Actions,
          edit,
          remove,
          restore,
        },
      }}
    />
  )
}

const CustomFields: React.FC = () => (
  <ProjectCustomFieldsProvider>
    <UserRoleSelectProvider>
      <CustomFieldPageProvider>
        <CustomFieldsTable />
      </CustomFieldPageProvider>
    </UserRoleSelectProvider>
  </ProjectCustomFieldsProvider>
)

export default CustomFields
